import { computed } from 'vue'
import { es, en, ca, de, fr, it, nl, no, pl, ro, ru, sv, ar, zhHans } from 'vuetify/locale'
import { idiomaSolicitud } from './solicitudTextos'

/**
 * Textos de Vuetify (calendario del contacto guiado) en los idiomas de las webs (data/solicitudWebTextos + español).
 * La instancia de Vuetify solo trae inglés: sin esto, el calendario avisa de que faltan sus textos
 * (ref: https://trello.com/c/FlzpRILR). Euskera no está en Vuetify: usa el español.
 */
const MENSAJES: Record<string, any> = { es, en, ca, de, fr, it, nl, no, pl, ro, ru, sv, ar, zhHans }
const CODIGO: Record<string, string> = { eu: 'es', zh: 'zhHans' }

export function useIdiomaVuetify() {
  const locale = computed(() => {
    const c = CODIGO[idiomaSolicitud.value] ?? idiomaSolicitud.value
    return MENSAJES[c] ? c : 'es'
  })
  const messages = computed(() => ({ en, [locale.value]: MENSAJES[locale.value] }))
  return { locale, messages }
}
